import { render, staticRenderFns } from "./Handlings.vue?vue&type=template&id=b3375b36"
import script from "./Handlings.vue?vue&type=script&lang=js"
export * from "./Handlings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports